import loadFromAttachment from './loadFromAttachment';
import loadFromProxy, { callProxy } from './loadFromProxy';
import loadImage from './loadImage';

export default async function loadFromImageTag(
    img: HTMLImageElement,
    context?: string,
    usePlaceHolder?: boolean,
    userIdentity?: string,
    delayRevoke?: boolean
) {
    const loadContext = context ? context : '';
    if (!(await loadFromAttachment(img, loadContext, !!usePlaceHolder, userIdentity))) {
        if (!(await loadFromProxy(img, callProxy, delayRevoke))) {
            loadImage(img, loadContext);
        }
    }
}
